import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ORingDesignTechnicalIndexRoutingModule } from './o-ring-design-technical-index-routing.module';
import { ORingDesignTechnicalIndexComponent } from './o-ring-design-technical-index.component';
import { PageHeaderModule } from '../page-header/page-header.module';
import { CtaFullWidthModule } from 'src/app/shared/cta-full-width/cta-full-width.module';

@NgModule({
  declarations: [ORingDesignTechnicalIndexComponent],
  imports: [
    CommonModule,
    ORingDesignTechnicalIndexRoutingModule,
    PageHeaderModule,
    CtaFullWidthModule
  ]
})
export class ORingDesignTechnicalIndexModule { }
